import React, { useState } from 'react'
import { Button } from '.'
import { useNavigate } from 'react-router-dom'
import { Dialog, IconButton } from '@mui/material'
import Spacer from 'src/components/Spacer'
import { Form as HSForm } from '../../components/form'

export function Form({ loc = 'uk', className = '' }) {
  const [requestDemoModalOpen, setRequestDemoModalOpen] = useState(false)
  const [email, setEmail] = useState('')
  const [err, setErr] = useState(false)

  const navigate = useNavigate()
  const handleSubmut = e => {
    e.preventDefault()
    var re = /\S+@\S+\.\S+/
    if (re.test(email)) {
      navigate('/online/' + loc + '/registration?email=' + (email || ''))
    } else {
      setErr(true)
    }
  }

  return (
    <div className={'row row-center mob-column mob-fw ' + className}>
      <form onSubmit={handleSubmut} className={'row row-center start-form mob-column mob-mb-20'}>
        <input
          value={email}
          onChange={e => {
            setEmail(e.target.value)
            setErr(false)
          }}
          placeholder='Enter your work email'
          className={'form-input ' + (err ? 'error' : '')}
          autoComplete={false}
        />
        <Button
          onClick={handleSubmut}
          variant={'contained'}
          sx={{ mr: '20px', padding: '0px 59px', fontSize: '16px', height: '72px', backgroundColor: '#0075BC' }}
        >
          activate
          <svg
            style={{ marginLeft: 30 }}
            width='8'
            height='10'
            viewBox='0 0 8 10'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M4.74299 5L0.875 1.17712L2.06601 0L7.125 5L2.06601 10L0.875 8.82288L4.74299 5Z'
              fill='white'
            />
          </svg>
        </Button>
      </form>

      <Dialog
        sx={{ '& .MuiPaper-root': { width: '100%', maxWidth: '600px' } }}
        onClose={() => setRequestDemoModalOpen(false)}
        open={requestDemoModalOpen}
      >
        <div className='row' style={{ padding: '10px 10px 0px 0px' }}>
          <Spacer />
          <IconButton onClick={() => setRequestDemoModalOpen(false)}>
            <svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M6.92358 6.75391L19.4236 19.2539' stroke='#444444' strokeWidth='1.75' strokeLinecap='round' />
              <path d='M6.92358 19.2461L19.4236 6.7461' stroke='#444444' strokeWidth='1.75' strokeLinecap='round' />
            </svg>
          </IconButton>
        </div>
        <HSForm />
      </Dialog>
    </div>
  )
}
